import { useMemo } from "react";
import { Case } from "../../../../models";
import { useFormSelectQuery } from "../../../../queries";
import { useNavigate } from "react-router-dom";
import { Lists } from "../../../lists";

export function ReferralHbovSummary({ case: _case }: Readonly<{ case: Case }>) {
    const navigate = useNavigate();
    const { getBySlugQuery: referralTypeQuery } = useFormSelectQuery({ slug: "referral_type" });
    const { potentialDonorType, id, number, patientLastName, overallStatus } = _case.referral ?? {};
    const hasAlert = useMemo(() => overallStatus === "Organ Case Pending OR Time", [overallStatus]);

    const referralType = useMemo(
        () =>
            referralTypeQuery.data?.formSelectOptions?.find((r) => r.value === potentialDonorType)?.displayName ?? "-",
        [potentialDonorType, referralTypeQuery.data?.formSelectOptions]
    );

    return (
        <tr
            key={id}
            className="clickable"
            onClick={() => {
                navigate(`/lists/${Lists.ReferralsHbov}/cases/${_case.id}/referral/${id}`);
            }}
        >
            <td>{number}</td>
            <td className="fw-bold">{patientLastName}</td>
            <td>{referralType}</td>
            <td className={hasAlert ? "fw-bold text-danger" : ""}>{overallStatus}</td>
        </tr>
    );
}
